var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoryFashionista(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "14px",
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/choose category") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.-V3-Account---uploaded",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.1-Influencer-view_Instagram-Copy-2-(2)",
    transform: "translate(-632.000000, -692.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(585.000000, 683.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.000000, 7.000000)",
    id: "hat"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 4.173913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C5.12313043,0 2.7826087,2.34052174 2.7826087,5.2173913 L2.7826087,11.4782609 C2.7826087,11.6703478 2.93834783,11.826087 3.13043478,11.826087 L12.8695652,11.826087 C13.0616522,11.826087 13.2173913,11.6703478 13.2173913,11.4782609 L13.2173913,5.2173913 C13.2173913,2.34052174 10.8768696,0 8,0 Z",
    id: "Path",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8695652,11.826087 L3.13043478,11.826087 C1.40438261,11.826087 0,10.4217043 0,8.69565217 C0,8.50356522 0.15573913,8.34782609 0.347826087,8.34782609 C0.539913043,8.34782609 0.695652174,8.50356522 0.695652174,8.69565217 C0.695652174,10.0382122 1.78787478,11.1304348 3.13043478,11.1304348 L12.8695652,11.1304348 C14.2121252,11.1304348 15.3043478,10.0382122 15.3043478,8.69565217 C15.3043478,8.50356522 15.460087,8.34782609 15.6521739,8.34782609 C15.8442609,8.34782609 16,8.50356522 16,8.69565217 C16,10.4217043 14.5956174,11.826087 12.8695652,11.826087 Z",
    id: "Path",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B3B3B3",
    x: 2.7826087,
    y: 7.65217391,
    width: 10.4347826,
    height: 3.47826087
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C5.12313043,0 2.7826087,2.34052174 2.7826087,5.2173913 L2.7826087,11.4782609 C2.7826087,11.6703478 2.93834783,11.826087 3.13043478,11.826087 L12.8695652,11.826087 C13.0616522,11.826087 13.2173913,11.6703478 13.2173913,11.4782609 L13.2173913,5.2173913 C13.2173913,2.34052174 10.8768696,0 8,0 Z",
    id: "Path",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8695652,11.826087 L3.13043478,11.826087 C1.40438261,11.826087 0,10.4217043 0,8.69565217 C0,8.50356522 0.15573913,8.34782609 0.347826087,8.34782609 C0.539913043,8.34782609 0.695652174,8.50356522 0.695652174,8.69565217 C0.695652174,10.0382122 1.78787478,11.1304348 3.13043478,11.1304348 L12.8695652,11.1304348 C14.2121252,11.1304348 15.3043478,10.0382122 15.3043478,8.69565217 C15.3043478,8.50356522 15.460087,8.34782609 15.6521739,8.34782609 C15.8442609,8.34782609 16,8.50356522 16,8.69565217 C16,10.4217043 14.5956174,11.826087 12.8695652,11.826087 Z",
    id: "Path",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#B3B3B3",
    x: 2.7826087,
    y: 7.65217391,
    width: 10.4347826,
    height: 3.47826087
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryFashionista);
export default __webpack_public_path__ + "static/media/category_fashionista.53d62bb3b4fe87de91f477f3c9a98d08.svg";
export { ForwardRef as ReactComponent };